import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import Tooltip from './tooltip';

const CustomFieldItem = ({ id, name, color, icon, selected, withTooltip, onClick }) => {
    const { t } = useTranslation('fields');

    const handleClick = () => {
        onClick && onClick(id);
    }

    return (
        <div className={'custom-field-selector-item' + (!withTooltip ? ' with-title' : '') + (selected ? ' selected' : '')} onClick={handleClick}>
            <Tooltip tooltip={ t(`types.${name}`) } disabled={!withTooltip}>
                <div className="item-inner">
                    <div className="item-icon" style={{ color }}>{ icon }</div>

                    {
                        !withTooltip ? (
                            <div className="item-title">{ t(`types.${name}`) }</div>
                        ) : null
                    }
                </div>
            </Tooltip>
        </div>
    );
}

const CustomFieldSelector = ({ withTooltips = true, disabled, options, selected, onSelect }) => {
    const computedOptions = useMemo(() => {
        if (disabled) {
            return [options.find(o => o.id === selected)];
        }

        return options;
    }, [disabled, options, selected]);

    return (
        <div className="custom-field-selector">
            {
                computedOptions.map(field => <CustomFieldItem
                    key={field.id}
                    id={field.id}
                    name={field.name}
                    color={field.color}
                    icon={field.icon}
                    withTooltip={withTooltips}
                    selected={field.id === selected}
                    onClick={!disabled && onSelect}
                />)
            }
        </div>
    );
}

export default CustomFieldSelector;
